import { Batch } from "@gearbox-protocol/sdk/permissionless";
import { useQuery } from "@tanstack/react-query";
import { useWeb3 } from "./use-web3";

export function useCurrentProposals() {
  const { crossChainMultisig } = useWeb3();

  const {
    data: currentProposals,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["current-proposals"],
    queryFn: async () => {
      if (!crossChainMultisig) {
        throw new Error("Not connected or contract not initialized");
      }

      try {
        const batches = await crossChainMultisig.getCurrentBatches();
        return batches as Batch[];
      } catch (err) {
        if (err instanceof Error) {
          throw new Error(`Failed to fetch current proposals: ${err.message}`);
        }
        throw new Error(
          "An unknown error occurred while fetching current proposals",
        );
      }
    },
    enabled: !!crossChainMultisig,
    retry: 3,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });

  return {
    currentProposals,
    isLoading,
    error: error as Error | null,
    refetch,
  };
}
